<template>
  <div class="thanks">
    <div class="container">
      <div class="text-center pt-5">
        <h3>
          <font-awesome-icon :icon="['far', 'heart']" style="color: #f68920" />
          ขอขอบคุณ
          <font-awesome-icon :icon="['far', 'heart']" style="color: #f68920" />
        </h3>
      </div>
      <p>
        มหาวิทยาลัยทักษิณขอขอบพระคุณเป็นอย่างสูงที่ได้ร่วมบริจาคมา ณ โอกาสนี้
        เราขอสัญญาว่าจะนำเงินบริจาคดังกล่าวไปใช้ให้เกิดประโยชน์ตามวัตถุประสงค์ของท่านต่อไป
      </p>
      <div class="text-center py-5">
        <a href="/" class="btn gradient-bg"
          ><font-awesome-icon :icon="['fas', 'house']" /> กลับหน้าหลัก</a
        >
      </div>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.thanks {
  width: 100%;
  background-image: url('../assets/images/thanks/thankyou.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  padding: 0;
}
</style>
